const skillsSet = [
  { name: "Javascript ES6+", important: true },
  { name: "TypeScript", important: true },
  { name: "React", important: true },
  { name: "React Router", important: false },
  { name: "Redux", important: true },
  { name: "Redux Toolkit", important: true},
  { name: "Context API", important: false },
  { name: "Node.js", important: true },
  { name: "Axios", important: false },
  { name: "Microservices", important: true },
  { name: "Docker", important: true },
  { name: "Docker Compose", important: false },
  { name: "Express.js", important: true },
  { name: "CSS 3", important: true },
  { name: "Responsive Design", important: true },
  { name: "RESTful APIs", important: true },
  // { name: "CSS Flexbox", important: false },
  // { name: "CSS Grid", important: false },
  { name: "HTML 5", important: true },
  { name: "Linux Shell", important: false },
  { name: "Java SE 8", important: true },
  { name: "Python", important: true },
  { name: "MongoDB", important: true },
  { name: "Mongoose", important: false },
  { name: "PostgreSQL", important: true },
  { name: "Firebase", important: false },
  { name: "Git/GitHub", important: true },
  { name: "Sass", important: false },
  { name: "Styled Components", important: false },
  { name: "Agile/Scrum", important: true },
  { name: "Unit Testing", important: true },
  { name: "Jest", important: false },
  { name: "Selenium", important: false },
  { name: "CI/CD", important: true },
  { name: "TDD", important: false },
  { name: "Regular Expressions", important: false },
  { name: "GitHub Actions", important: false },
  { name: "NPM", important: false },
  { name: "Next.js", important: true },
  { name: "English", important: true },
  { name: "JWT", important: true },
  { name: "OAuth2", important: true },
  { name: "CORS", important: true },
  { name: "HTTP", important: false },
  { name: "Passport.js", important: false },
  { name: "Data Structures", important: true },
];

export default skillsSet;
